(function () {
    'use strict';

    angular
        .module('app')
        .factory('EmailAddressService', EmailAddressService);

    EmailAddressService.$inject = ['$http', '$q', 'DataService', 'UrlService'];

    function EmailAddressService($http, $q, DataService, UrlService) {
        var resourceUrl = 'emailaddress';
        var service = {};

        angular.extend(service, DataService(resourceUrl));

        angular.extend(service, {
            getAudits: getAudits,
            block: block
        });

        return service;

        /**
         * GET the audit records for the specified email address
         *
         * @param {int} emailAddressId - Id of the email address for which audits are to be returned
         * @param {int} currentPage - The current page of the list. Optional - If used then pageSize must also be set or it will be ignored.
         * @param {int} pageSize - The page size of the list. Optional - If used then currentPage must also be set or it will be ignored.
         */
        function getAudits(emailAddressId, currentPage, pageSize) {
            var url = UrlService.getWebAPIUrl() + '/' + resourceUrl + '/' + emailAddressId + '/audit';

            if (!_.isNil(currentPage) && !_.isNil(pageSize)) {
                url += '/?currentpage=' + currentPage + '&pagesize=' + pageSize;
            }

            return $http.get(url)
                .then(function (response) {
                    return response.data;
                }, function (response) {
                    return $q.reject(response);
                });
        }

        /**
         * Block/Unblock the specified email addresses
         *
         * @param {array} selectedEmailAddressIds - Array of ids for the email addresses which are to be blocked
         * @param {bool} block - If true the email addresses will be blocked, otherwise they will be unblocked.
         */
        function block(emailAddressIds, block) {
            var url = UrlService.getWebAPIUrl() + '/' + resourceUrl + '/block';

            url += convertQueryParams({ emailAddressIds: emailAddressIds, block: block });

            return $http.post(url);
        }

        function convertQueryParams(queryParams) {
            var parameterString = '';

            if (angular.isDefined(queryParams) && queryParams !== null) {
                for (var queryProperty in queryParams) {
                    if (queryParams.hasOwnProperty(queryProperty) && angular.isDefined(queryParams[queryProperty]) && queryParams[queryProperty] !== null) {
                        if (_.isArray(queryParams[queryProperty])) {
                            _.forEach(queryParams[queryProperty], appendArrayParamProperty);
                        } else {
                            parameterString += parameterString.length > 0 ? '&' : '?';
                            parameterString += queryProperty + '=' + queryParams[queryProperty];
                        }
                    }
                }
            }

            return parameterString;

            function appendArrayParamProperty(property) {
                parameterString += parameterString.length > 0 ? '&' : '?';
                parameterString += queryProperty + '=' + property;
            }
        }
    }
})();